export default "__VITE_ASSET__DraHwvmB__"